import React from 'react';

import {
    IconCheck,
    IconClose
} from '$partials/icons';

import { formatLinkBlockToUrl } from '$utilities/format';
import { isLocalURL } from '$utilities/browser';
import { usePage } from '$contexts/page.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').SubscriptionBlock}
 */
const Subscription = ({
    additionalText,
    id,
    options,
    text,
    title
}) => {
    const { page } = usePage();

    return (
        <div className='col-wrapper-breakout bg-surface-panel-blue rounded-lg pt-24 pb-16'>
            <h2 className='col-padding type-style-sans-h1 w-full md:w-5/12'>
                {title}
            </h2>

            {text && (
                <p className='col-padding type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'>
                    {text}
                </p>
            )}

            {options?.length > 0 && (
                <ul className='flex flex-wrap mt-16 md:mt-24'>
                    {options.map((option, idx) => {
                        const isCtaLinkLocal = isLocalURL(formatLinkBlockToUrl(option.ctaLink));

                        return (
                            <li
                                className='w-full sm:w-6/12 col-padding'
                                key={option.id}>
                                <div className={`${!idx ? 'bg-surface-raised': ''} p-24 sm:p-32 rounded-lg flex flex-col relative`}>
                                    {!idx && (
                                        <div className='flex self-start mb-12 sm:mb-0 sm:absolute top-24 right-24 sm:top-32 sm:right-32 tag-primary'>
                                            <p>
                                                Most popular
                                            </p>
                                        </div>
                                    )}

                                    <p className='type-style-sans-h3'>
                                        {option.title}
                                    </p>

                                    <p className='type-style-sans-body mt-8'>
                                        {option.text}
                                    </p>

                                    <p className='type-style-sans-body mt-8'>
                                        {option.priceText}
                                    </p>

                                    <div className='mt-32 flex flex-col gap-y-8'>
                                        {option.highlights.map(item => {
                                            return (
                                                <div
                                                    className='flex flex-row items-center gap-x-8'
                                                    key={item.id}>
                                                    {item.excluded ? <IconClose/> : <IconCheck/>}
                                                    <p className='type-style-sans-body'>
                                                        {item.highlight}
                                                    </p>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {option.ctaMobileUrlOverride ? (
                                        <>
                                            <a
                                                className={`sm:hidden mt-32 flex self-start ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}`}
                                                data-analytics-action='click'
                                                data-analytics-context={title}
                                                data-analytics-destination={option.ctaMobileUrlOverride}
                                                data-analytics-id={`${page?.id}_${id}_subscription_cta_${idx}`}
                                                data-analytics-label={option.ctaLabel}
                                                data-analytics-location='modules'
                                                data-analytics-module='subscription_cta'
                                                href={option.ctaMobileUrlOverride}
                                                rel='noreferrer'
                                                target='_blank'>
                                                {option.ctaLabel}
                                            </a>
                                            <a
                                                className={`hidden sm:flex mt-32 self-start ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${option.ctaCssClass ? ' ' + option.ctaCssClass : ''}`}
                                                data-analytics-action='click'
                                                data-analytics-context={title}
                                                data-analytics-destination={formatLinkBlockToUrl(option.ctaLink)}
                                                data-analytics-id={`${page?.id}_${id}_subscription_cta_${idx}`}
                                                data-analytics-label={option.ctaLabel}
                                                data-analytics-location='modules'
                                                data-analytics-module='subscription_cta'
                                                href={formatLinkBlockToUrl(option.ctaLink)}
                                                rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                                target={isCtaLinkLocal ? undefined : '_blank' }>
                                                {option.ctaLabel}
                                            </a>
                                        </>
                                    ) : (
                                        <a
                                            className={`mt-32 flex self-start ${idx ? 'button-outcome-xl': 'button-primary-xl'}${option.ctaCssClass ? ' ' + option.ctaCssClass : ''}`}
                                            data-analytics-action='click'
                                            data-analytics-context={title}
                                            data-analytics-destination={formatLinkBlockToUrl(option.ctaLink)}
                                            data-analytics-id={`${page?.id}_${id}_subscription_cta_${idx}`}
                                            data-analytics-label={option.ctaLabel}
                                            data-analytics-location='modules'
                                            data-analytics-module='subscription_cta'
                                            href={formatLinkBlockToUrl(option.ctaLink)}
                                            rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                            target={isCtaLinkLocal ? undefined : '_blank' }>
                                            {option.ctaLabel}
                                        </a>
                                    )}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}

            {additionalText && (
                <p className='col-padding w-full mt-16 text-center'>
                    {additionalText}
                </p>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Subscription;
